import React, { useMemo } from "react";

import { formatCurrency } from "@/utils/formatCurrency";

function Tile({ label, value, accent = "text-[#333333]" }) {
  return (
    <div className="flex flex-col gap-1 min-w-[150px]">
      <p className="text-sm text-[#666]">{label}</p>
      <span className={`text-[20px] font-semibold ${accent}`}>{value}</span>
    </div>
  );
}

export default function TransactionsSummary({ transactions = [] }) {
  const stats = useMemo(() => {
    let grossSales = 0;
    let refunds = 0;
    let count = transactions.length;

    transactions.forEach((txn) => {
      if (txn.type === "sale" && txn.status === "completed") grossSales += txn.total;
      if (txn.type === "refund") refunds += Math.abs(txn.total);
    });

    return { count, grossSales, refunds, net: grossSales - refunds };
  }, [transactions]);

  return (
    <div className="mb-6 rounded-lg bg-white border border-[#e4e4e4] px-5 py-4 shadow-sm">
      <div className="flex flex-wrap gap-8">
        <Tile label="Transactions" value={stats.count} />
        <Tile label="Gross Sales" value={formatCurrency(stats.grossSales)} accent="text-green-600" />
        <Tile label="Refunds" value={formatCurrency(stats.refunds)} accent="text-red-600" />
        <Tile label="Net" value={formatCurrency(stats.net)} />
      </div>
    </div>
  );
}
